var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"resize-box"},[_c('div',{staticClass:"resize-bar",style:({width: _vm.defaultWidth})}),_c('div',{staticClass:"resize-line"}),_c('div',{staticClass:"resize-content"},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }